import { useTranslation } from 'react-i18next';

import { ReactNode } from 'react';

import { IconAlertHexagon } from '@tabler/icons-react';

import { Button, CardShellView, Group, Modal, Stack, Text, Title } from '@optiro/ui';

interface AlertProps {
  open: boolean;
  setClose: (value: boolean) => void;
  title: string;
  onSubmit: () => void;
  error?: string;
  children: ReactNode;
}

export const Alert = ({ open, setClose, title, onSubmit, error, children }: AlertProps) => {
  const { t } = useTranslation('errors');

  return (
    <Modal
      opened={open}
      zIndex={1000}
      size={'lg'}
      onClose={() => setClose(false)}
      title={
        <Group gap="xs">
          <IconAlertHexagon size={24} stroke={1.5} />
          <Title order={4}>{title}</Title>
        </Group>
      }
      centered
      withCloseButton={false}
      radius="md"
    >
      <Stack gap="md">
        {children}
        {error && (
          <CardShellView withBorder style={{ borderColor: 'red' }}>
            <Group gap="xs">
              <IconAlertHexagon color="red" size={20} stroke={1.5} />
              <Text c="red">{t(error)}</Text>
            </Group>
          </CardShellView>
        )}
        <Group justify="flex-end" mt="md">
          <Button color="red" variant="filled" onClick={onSubmit}>
            Bekræft
          </Button>
          <Button variant="default" onClick={() => setClose(false)}>
            Afbryd
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
